import React from 'react';
import { CheckIcon, ClockIcon, CreditCardIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
interface OfferCardProps {
  badge?: string;
  title: string;
  subtitle: string;
  oldPrice: string;
  price: string;
  highlight?: boolean;
  note?: string;
  includes: string[];
  ctaLabel: string;
  ctaHref?: string;
}
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Pago seguro'
}, {
  icon: ClockIcon,
  label: 'Acceso en 5 min'
}, {
  icon: CheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function OfferCard({
  badge,
  title,
  subtitle,
  oldPrice,
  price,
  highlight = false,
  note,
  includes,
  ctaLabel,
  ctaHref
}: OfferCardProps) {
  return <div className={`relative flex h-full flex-col rounded-2xl p-5 sm:p-8 ${highlight ? 'bg-forest-800 text-cream-50 shadow-lift ring-2 ring-gold-400' : 'bg-cream-50 text-forest-900 ring-1 ring-inset ring-forest-900/10'}`} data-id="element-169" data-mp="15gg8k8du56e6">
      {badge ? <span className="absolute -top-2.5 left-5 rounded-full bg-gold-400 px-2.5 py-0.5 text-[0.6rem] font-bold uppercase tracking-[0.12em] text-forest-950 sm:-top-3 sm:left-7 sm:px-3 sm:py-1 sm:text-[0.65rem] sm:tracking-[0.15em]" data-id="element-170" data-mp="8h48arsep3m1">
          {badge}
        </span> : null}

      <h3 className={`font-display text-base leading-tight sm:text-xl ${highlight ? 'text-cream-50' : 'text-forest-900'}`} style={{
      fontWeight: 700
    }} data-id="element-171" data-mp="3ob7ug3z0hfr">
        {title}
      </h3>
      <p className={`mt-1 text-[0.75rem] sm:mt-1.5 sm:text-sm ${highlight ? 'text-cream-200' : 'text-forest-900/60'}`} data-id="element-172" data-mp="3qvdj1ih2a4gt">
        {subtitle}
      </p>

      <div className="mt-4 flex items-end gap-2.5 sm:mt-6 sm:gap-3" data-id="element-173" data-mp="3gvcuni4c4y5r">
        <span className={`font-display text-base line-through sm:text-lg ${highlight ? 'text-cream-200/60' : 'text-forest-900/40'}`} data-id="element-174" data-mp="3gxpbtt29r4hr">
          {oldPrice}
        </span>
        <span className={`font-display text-[2.1rem] leading-none sm:text-5xl ${highlight ? 'text-gold-400' : 'text-forest-900'}`} style={{
        fontWeight: 700
      }} data-id="element-175" data-mp="1f1x0wccyb36k">
          {price}
        </span>
      </div>
      <p className={`mt-1.5 text-[0.7rem] sm:mt-2 sm:text-xs ${highlight ? 'text-cream-200/70' : 'text-forest-900/50'}`} data-id="element-176" data-mp="2f1b79sdw2s7w">
        Pago único · sin suscripción
      </p>

      <ul className="mt-4 space-y-1.5 sm:mt-6 sm:space-y-2.5" data-id="element-177" data-mp="36s7ikokawot2">
        {includes.map(item => <li key={item} className="flex items-start gap-2 text-[0.8rem] sm:gap-2.5 sm:text-sm" data-id="element-178" data-mp="32pkqcmjpx1vc">
            <CheckIcon className={`mt-0.5 h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4 ${highlight ? 'text-gold-400' : 'text-forest-600'}`} aria-hidden="true" data-id="element-179" data-mp="2xyufwuwfq8ts" />
            <span className={highlight ? 'text-cream-100' : 'text-forest-900/80'} data-id="element-180" data-mp="3qggnlz6y0p9z">{item}</span>
          </li>)}
      </ul>

      {note ? <p className={`mt-4 rounded-lg px-3 py-2.5 text-[0.75rem] leading-snug sm:mt-6 sm:rounded-xl sm:px-4 sm:py-3 sm:text-sm ${highlight ? 'bg-forest-950/40 text-cream-100' : 'bg-cream-100 text-forest-900/70'}`} data-id="element-181" data-mp="3t037ajifpf9c">
          {note}
        </p> : null}

      <div className="mt-auto pt-5 sm:pt-7" data-id="element-182" data-mp="aui745hjkv2l">
        <CtaButton href={ctaHref} className="w-full" data-id="element-183" data-mp="av9q8gtyd0bz">
          {ctaLabel}
        </CtaButton>
        <ul className={`mt-3 flex flex-wrap justify-center gap-x-3 gap-y-1 text-[0.65rem] font-medium sm:mt-4 sm:gap-x-4 sm:gap-y-1.5 sm:text-[0.7rem] ${highlight ? 'text-cream-200/75' : 'text-forest-900/55'}`} data-id="element-184" data-mp="fsjqkrivqwel">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1" data-id="element-185" data-mp="uir02hqwt535">
              <item.icon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-186" data-mp="ykcgue6ke3im" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </div>;
}